import EmaInput from "components/emaInput/EmaInput";
import CountryRegionInput from "components/country-region-input/CountryRegionInput";
import findError from "utils/findError";
import PhoneInput from "react-phone-number-input";
import "assets/styles/PhoneInput.sass";
import { useTranslation } from "react-i18next";
function NewUserForm({ newUser , setNewUser, handleChange, disableInputs, errors, index }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="ema-card">
        <div className="ema-card-title">{t("Basic")}</div>
        <div className="row">
          <div className="col col-6">
            <EmaInput
              name="givenName"
              value={newUser.name}
              label={t("Name")}
              error={findError("name", errors)}
              disabled={disableInputs}
              required
              onChange={handleChange}
            />
          </div>
          <div className="col col-6">
            <EmaInput
              name="familyName"
              value={newUser.familyName}
              label={t("Family Name")}
              onChange={handleChange}
              error={findError("familyName", errors)}
              disabled={disableInputs}
              required
            />
          </div>

          <div className="col col-6">
            <EmaInput
              name="email"
              label={t("Email")}
              onChange={handleChange}
              value={newUser.email}
              error={findError("email", errors)}
              disabled={disableInputs}
              required
            />
          </div>
          <div className="col col-6">
            <label className="phone-input-label" htmlFor="phone">
              Primary Phone{/* <span className="required-red">*</span> */}
            </label>
            <PhoneInput
              className={
                "phone-input"
                //classNames("phone-input", {
                //"phone-error": findError(`[${index}].Phone`, errors),})
              }
              defaultCountry="ET"
              international
              value={newUser.phone}
              onChange={(value) =>
                setNewUser((prev) => ({
                  ...prev,
                  phone: value,
                }))
              }
            />
            <span className="phone-error-message">
              {findError(`[${index}].phone`, errors)}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewUserForm;

